/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import normalizeSidebarWorkspaceLabel from '@/redux/lib/normalizeSidebarWorkspaceLabel.js';
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';
import { sidebar } from '@/redux/selectors/pieveSelectors/baseSelectors.js';

export const storedSidebarRecentItems = (state) => sidebar(state)?.recentItems || EMPTY_ARRAY;
export const storedWorkspaceName = (state) => sidebar(state)?.workspaceName;
export const storedWorkspaceLabel = (state) => normalizeSidebarWorkspaceLabel(sidebar(state)?.workspaceLabel);

export const recentSidebarItems = storedSidebarRecentItems;
export const workspaceName = storedWorkspaceName;
export const workspaceLabel = storedWorkspaceLabel;
